export default __webpack_public_path__ + "static/media/kicjer.50c848dd.png";